var _circle, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#ACB1B6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.76934,
    y: 3.0003,
    width: 0.461538,
    height: 3.23077,
    fill: "#070707",
    stroke: "#ACB1B6",
    strokeWidth: 0.461538
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.07685,
    y: 6.69268,
    width: 0.461538,
    height: 2.30769,
    transform: "rotate(90 8.07685 6.69268)",
    fill: "#070707",
    stroke: "#ACB1B6",
    strokeWidth: 0.461538
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWaiting);
export default __webpack_public_path__ + "static/media/status-waiting.482e3e8bf513054edb623621f26a2f69.svg";
export { ForwardRef as ReactComponent };